import { apiService } from './api.service'

export enum FileVersion {
  Archive = 'archive',
  Original = 'original',
}

export interface ShareLink {
  id: number
  slug: string
  created: string
  expiration: string | null
  document: number
  file_version: FileVersion
}

class ShareLinkService {
  async getLinksForDocument(documentId: number): Promise<ShareLink[]> {
    const response = await apiService.get<ShareLink[]>(`documents/${documentId}/share_links/`)
    return response.data
  }

  async createLinkForDocument(
    documentId: number,
    fileVersion: FileVersion = FileVersion.Archive,
    expiration: Date | null = null
  ): Promise<ShareLink> {
    const response = await apiService.post<ShareLink>('share_links/', {
      document: documentId,
      file_version: fileVersion,
      expiration: expiration?.toISOString(),
    })
    return response.data
  }

  async deleteLink(link: ShareLink): Promise<void> {
    await apiService.delete(`share_links/${link.id}/`)
  }
}

export const shareLinkService = new ShareLinkService()
